export const getLeftForIcon = () => {
  const { innerWidth: width } = window;
  const percentage = width * 0.2;
  return percentage > 360 ? 360 : percentage;
};
